import { PayloadAction } from '@reduxjs/toolkit';
import app from 'Cloud/Application/app';
import config from 'Cloud/config';
import { logger } from 'lib/logger';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { addFilesSuccess } from 'reactApp/modules/modifying/modifying.actions';
import { EModifyReason } from 'reactApp/modules/modifying/modifying.types';
import { sendPublicAnalytics } from 'reactApp/modules/public/public.saga';
import { routeChangeSuccess, routerStart } from 'reactApp/modules/router/router.module';
import { getCurrentRouteId } from 'reactApp/modules/router/router.selectors';
import { loadStockFolder, loadStockMoreRequest, loadStockMoreSuccess } from 'reactApp/modules/stock/stock.module';
import { ApiStockFolderResponse, ApiStockLoadMore } from 'reactApp/modules/stock/stock.type';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { openMobileViewer as openMobileViewerAction } from 'reactApp/modules/viewer/viewer.module';
import { put, select, takeEvery } from 'redux-saga/effects';

function* openMobileViewer() {
    const id = yield select(getCurrentRouteId);

    if (IS_PHONE_BROWSER) {
        yield put(openMobileViewerAction({ id }));
    }
}

function* loadStock(action) {
    const storage = action.payload.storage;

    if (storage !== EStorageType.stock) {
        return;
    }

    const serverSideStock = config.get('serverSideFolders')?.folder;
    let folder: ApiStockFolderResponse;

    if (serverSideStock?.kind !== 'storage') {
        if (serverSideStock?.list && serverSideStock?.kind === 'folder') {
            folder = serverSideStock;
        } else {
            folder = yield Promise.resolve(app.loadFolder(action.payload.id, EStorageType.stock, 0, true));
        }

        yield put(loadStockFolder(folder));

        yield openMobileViewer();

        yield sendPublicAnalytics(action.payload.id);
    } else {
        const item = serverSideStock?.list[0];

        yield put(
            addFilesSuccess({
                items: [
                    {
                        ...item,
                        name: item.name || item.id.split('/').pop(),
                        home: item.home,
                    },
                ],
                parent: '',
                storage: EStorageType.stock,
                reason: EModifyReason.add,
            })
        );
    }
}

function* stockLoadMore(action: PayloadAction<ApiStockLoadMore>) {
    const { offset, id } = action.payload;

    try {
        const folder = yield Promise.resolve(app.loadFolder(id, EStorageType.stock, offset, true));

        yield put(loadStockMoreSuccess(folder));
    } catch (error) {
        logger.error(error);
    }
}

export function* watchStock() {
    yield takeEvery(routerStart.toString(), loadStock);
    yield takeEvery(routeChangeSuccess.toString(), openMobileViewer);
    yield takeEvery(loadStockMoreRequest.toString(), stockLoadMore);
}
